/* tslint:disable */
/* eslint-disable */
/**
 * Jack Burton Internal API
 * API for the Jack Burton platform
 *
 * The version of the OpenAPI document: v1 App
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime.js';
import type { ParticipantRole } from './ParticipantRole.js';
import {
    ParticipantRoleFromJSON,
    ParticipantRoleFromJSONTyped,
    ParticipantRoleToJSON,
} from './ParticipantRole.js';

/**
 * 
 * @export
 * @interface ContactParticipation
 */
export interface ContactParticipation {
    /**
     * 
     * @type {number}
     * @memberof ContactParticipation
     */
    id?: number;
    /**
     * 
     * @type {number}
     * @memberof ContactParticipation
     */
    contactId?: number;
    /**
     * 
     * @type {number}
     * @memberof ContactParticipation
     */
    systemUserId?: number;
    /**
     * 
     * @type {number}
     * @memberof ContactParticipation
     */
    agentId?: number;
    /**
     * 
     * @type {string}
     * @memberof ContactParticipation
     */
    firstName?: string;
    /**
     * 
     * @type {string}
     * @memberof ContactParticipation
     */
    lastName?: string;
    /**
     * 
     * @type {ParticipantRole}
     * @memberof ContactParticipation
     */
    role?: ParticipantRole;
    /**
     * 
     * @type {Date}
     * @memberof ContactParticipation
     */
    dateTransferred?: Date;
}

/**
 * Check if a given object implements the ContactParticipation interface.
 */
export function instanceOfContactParticipation(value: object): boolean {
    return true;
}

export function ContactParticipationFromJSON(json: any): ContactParticipation {
    return ContactParticipationFromJSONTyped(json, false);
}

export function ContactParticipationFromJSONTyped(json: any, ignoreDiscriminator: boolean): ContactParticipation {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'contactId': json['contactId'] == null ? undefined : json['contactId'],
        'systemUserId': json['systemUserId'] == null ? undefined : json['systemUserId'],
        'agentId': json['agentId'] == null ? undefined : json['agentId'],
        'firstName': json['firstName'] == null ? undefined : json['firstName'],
        'lastName': json['lastName'] == null ? undefined : json['lastName'],
        'role': json['role'] == null ? undefined : ParticipantRoleFromJSON(json['role']),
        'dateTransferred': json['dateTransferred'] == null ? undefined : (new Date(json['dateTransferred'])),
    };
}

export function ContactParticipationToJSON(value?: ContactParticipation | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'contactId': value['contactId'],
        'systemUserId': value['systemUserId'],
        'agentId': value['agentId'],
        'firstName': value['firstName'],
        'lastName': value['lastName'],
        'role': ParticipantRoleToJSON(value['role']),
        'dateTransferred': value['dateTransferred'] == null ? undefined : ((value['dateTransferred']).toISOString()),
    };
}

